import api from 'api/axiosInstance';
import type {
  CashAvailableFactorsType,
  CashAvailableSettingsType,
} from 'types/transactions.types';

const getCashAvailableFactors = (): Promise<CashAvailableFactorsType> =>
  api.get('/v2/settings/cash-available').then(({ data }) => data);

const updateCashAvailableSettings = (
  settings: CashAvailableSettingsType,
): Promise<CashAvailableSettingsType> =>
  api.patch('/v2/settings/cash-available', settings).then(({ data }) => data);

export { getCashAvailableFactors, updateCashAvailableSettings };
